import classNames from "classnames";

import { roundAndDropTrailingZeros, translate } from "@ascendnow/shared";

import styles from "./AscBaselineAssessmentAttempt.module.scss";
// import { CheckActiveIcon } from "../AscIcons";

export interface AscBaselineAssessmentAttemptSingleProps {
  attempt: 1 | 2 | 3;
  attemptResult?: number | string;
  count?: number;
  totalCount?: number;
  className?: string;
}

export default function AscBaselineAssessmentAttemptSingle({
  attempt,
  attemptResult,
  count = 0,
  totalCount = 0,
  className,
}: AscBaselineAssessmentAttemptSingleProps) {
  return (
    <div
      data-testid="asc-baseline-assessment-attempt"
      className={classNames(styles.ground, className)}
    >
      <span className={styles.title}>
        {translate("baselineAssessment")} - {translate("attempt")} {attempt}
      </span>
      {totalCount && count ? (
        <span className={styles.count}>
          {totalCount > 0 ? totalCount : "N"}/
          {count >= 0 && totalCount > 0 ? count : "A"}
        </span>
      ) : (
        <span className={styles.attempted}>
          {typeof attemptResult !== "undefined" &&
          attemptResult !== null &&
          Number(attemptResult) >= 0
            ? roundAndDropTrailingZeros(Number(attemptResult)) + "%"
            : "N/A"}
        </span>
      )}
    </div>
  );
}
